import $ from 'jquery';
import Store from './store';
var DrawView = {};
(function(){
    var winW = document.documentElement.clientWidth;
    var baseNum = Store.getUrlParam("width") == 750 ? 375 : 960;
    var _timer;
    var $html = $('html');
    DrawView.rem = (winW / baseNum * 50).toFixed(4);
    $html.css('font-size', DrawView.rem + 'px');
    $(window).resize(function(){
        clearTimeout(_timer);
        _timer = setTimeout(function(){
            if(document.documentElement.clientWidth !== winW) {
                winW = document.documentElement.clientWidth;
                DrawView.rem = (winW / baseNum * 50).toFixed(4);
                $html.css('font-size', DrawView.rem + 'px');
            }
        },40);
    });
})();


// WEBPACK FOOTER //
// ./src/commonjs/fontSize.js